import { render, staticRenderFns } from "./searchConfig.vue?vue&type=template&id=232172fd&scoped=true"
import script from "./searchConfig.vue?vue&type=script&lang=js"
export * from "./searchConfig.vue?vue&type=script&lang=js"
import style0 from "./searchConfig.vue?vue&type=style&index=0&id=232172fd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "232172fd",
  null
  
)

export default component.exports